import type { MouseEvent, PointerEvent } from 'react';

import {
  isMadBuyLineItemScheduleHourSelected,
  type MadBuyLineItemDayTimeActivity,
  type MadBuyLineItemWeekDay,
} from '../../lineItemsModel';
import {
  formatScheduleDayLabel,
  formatScheduleHourLabel,
  scheduleHours,
} from './LineItemSchedule.helpers';
import { ScheduleHourButton } from './ScheduleHourButton';

export function LineItemScheduleDayRow({
  activities,
  day,
  onClick,
  onPointerDown,
  onPointerEnter,
}: {
  activities: MadBuyLineItemDayTimeActivity[];
  day: MadBuyLineItemWeekDay;
  onClick: (hour: number, event: MouseEvent<HTMLButtonElement>) => void;
  onPointerDown: (hour: number, selected: boolean, event: PointerEvent<HTMLButtonElement>) => void;
  onPointerEnter: (hour: number) => void;
}) {
  return (
    <>
      <span className="text-foreground flex h-8 items-center text-xs font-semibold">
        {formatScheduleDayLabel(day)}
      </span>
      {scheduleHours.map((hour) => {
        const selected = isMadBuyLineItemScheduleHourSelected(activities, day, hour);

        return (
          <ScheduleHourButton
            key={`${day}-${String(hour)}`}
            ariaLabel={`${formatScheduleDayLabel(day)} ${formatScheduleHourLabel(hour)}`}
            selected={selected}
            onClick={(event) => {
              onClick(hour, event);
            }}
            onPointerDown={(event) => {
              onPointerDown(hour, selected, event);
            }}
            onPointerEnter={() => {
              onPointerEnter(hour);
            }}
          />
        );
      })}
    </>
  );
}
